import { useSegment } from '@hooks/useSegment';
import {
  useAssistantPaymentActions,
  useAssistantPaymentOptions,
} from '../zustand/assistantPaymentOptionsStore';
import { SwitchCard } from './SwitchCard';

interface Props {
  label: string;
  loading: boolean;
}

export function AssistantPaymentSwitch({ label, loading }: Props) {
  const { track } = useSegment();
  const { sendEmail, chargeDeliveryCost } = useAssistantPaymentOptions();
  const { setSendEmail, setChargeDeliveryCost } = useAssistantPaymentActions();

  const handleChangeSkipDeliveryCost = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setChargeDeliveryCost(event.target.checked);
    track('change charge delivery cost', {
      activated: event.target.checked,
    });
  };

  const handleChangeSendEmail = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setSendEmail(event.target.checked);
    track('change send email', {
      activated: event.target.checked,
    });
  };

  const onChange =
    label == 'Enviar email'
      ? handleChangeSendEmail
      : handleChangeSkipDeliveryCost;
  const checked = label == 'Enviar email' ? sendEmail : chargeDeliveryCost;

  return (
    <SwitchCard
      label={label}
      onChange={onChange}
      checked={checked}
      loading={loading}
    />
  );
}
